import { Analytics } from "@bounce/analytics"
import { useLocale } from "@bounce/i18n"

import { InteractionEvents } from "@/libs/analytics/events"
import type { StorageSpotFragment } from "@/libs/bounce/bounceSdk.types.gen"
import { getStoreUrlPath, useUrl } from "@/libs/router"
import { useAppURL } from "@/utils/appURL"

export type UseStoreSuggestionsProps = {
  searchQuery?: string | null
  from?: string
  couponCode?: string | undefined
}

export const useStoreSuggestions = ({ searchQuery, couponCode, from }: UseStoreSuggestionsProps) => {
  const { getUrl } = useUrl()
  const buildAppURL = useAppURL()
  const { language } = useLocale()

  const handleGetStoreUrl = (store: StorageSpotFragment) => {
    if (store.marketingPageEnabled) {
      return getUrl({
        path: getStoreUrlPath({ store }),
        language,
      })
    }

    return buildAppURL(getUrl({ path: `/s/location/${store.id}` }), {
      query: searchQuery,
      coupon: couponCode,
    })
  }

  const handleClickStore = (
    ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    store: StorageSpotFragment,
    opts = {},
  ) => {
    ev.preventDefault()

    const href = handleGetStoreUrl(store)

    Analytics.track(InteractionEvents.FeaturedStoresStoreCardPressed, { from, destination: href, ...opts })
    location.assign(href)
  }

  return { handleGetStoreUrl, handleClickStore }
}
